import { Appliance, ApplianceId } from '../engine/types';

// Drain values are abstract energy units per game hour, tuned for play balance —
// only their relative sizes are meant to teach (AC >> lights).
export const APPLIANCES: Record<ApplianceId, Appliance> = {
  [ApplianceId.DISHWASHER]: {
    drainPerHour: 1.2,
    id: ApplianceId.DISHWASHER,
    name: 'Dishwasher',
    room: 'kitchen',
  },
  [ApplianceId.EV_CHARGER]: {
    drainPerHour: 4,
    id: ApplianceId.EV_CHARGER,
    name: 'EV charger',
    room: 'garage',
  },
  [ApplianceId.FRIDGE]: {
    drainPerHour: 0.3,
    essential: true,
    id: ApplianceId.FRIDGE,
    name: 'Fridge',
    room: 'kitchen',
  },
  [ApplianceId.HVAC]: {
    drainPerHour: 2.5,
    id: ApplianceId.HVAC,
    name: 'Heating & cooling',
    room: 'utility',
  },
  [ApplianceId.LAUNDRY]: {
    drainPerHour: 1.5,
    id: ApplianceId.LAUNDRY,
    name: 'Washer & dryer',
    room: 'utility',
  },
  [ApplianceId.LIGHTS]: {
    drainPerHour: 0.2,
    id: ApplianceId.LIGHTS,
    name: 'Lights',
    room: 'living',
  },
  [ApplianceId.OVEN]: {
    drainPerHour: 2,
    id: ApplianceId.OVEN,
    name: 'Oven & stove',
    room: 'kitchen',
  },
  [ApplianceId.TV_CONSOLE]: {
    drainPerHour: 0.5,
    id: ApplianceId.TV_CONSOLE,
    name: 'TV & games',
    room: 'living',
  },
  [ApplianceId.WATER_HEATER]: {
    drainPerHour: 2.5,
    id: ApplianceId.WATER_HEATER,
    name: 'Water heater',
    room: 'bathroom',
  },
  [ApplianceId.WIFI]: {
    drainPerHour: 0.1,
    essential: true,
    id: ApplianceId.WIFI,
    name: 'Wi-Fi',
    room: 'living',
  },
};
